import { Flex } from "@capioweb/ui-components"
import React, { useState } from "react"
import { XhtmlString } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { BmiCard } from "../../components/CapioNexusBmiBlock/BmiCard"
import { BmiHeader } from "../../components/CapioNexusBmiBlock/BmiHeader"
import { BmiResult } from "../../components/CapioNexusBmiBlock/BmiResult"
import { useBmi } from "../../components/CapioNexusBmiBlock/useBmi"
import {
	calculateBmi,
} from "../../components/CapioNexusBmiBlock/utils/calculateBmi"

interface CapioNexusBmiPageProps {
	header: StringProperty
	preamble: StringProperty
	underweight: XhtmlString
	normalWeight: XhtmlString
	overweight: XhtmlString
	obesity: XhtmlString
	calculatorTitle: StringProperty
	calculatorPreamble: StringProperty
	heightInput: string
	weightInput: string
	heightUnit: string
	weightUnit: string
	submitButton: string
	bmi: string
	yourBMI: string
	underWeight: string
	normalweight: string
	overWeight: string
	obese: string
}

// TODO: Resolve correct props, name and add to pageResolver
export const CapioNexusBmiPage: React.FC<CapioNexusBmiPageProps> = ({
	header,
	preamble,
	underweight,
	normalWeight,
	overweight,
	obesity,
	calculatorTitle,
	calculatorPreamble,
	heightInput,
	weightInput,
	heightUnit,
	weightUnit,
	submitButton,
	bmi: bmiString,
	yourBMI,
	underWeight,
	normalweight,
	overWeight,
	obese,
}) => {
	const {
		getLength,
		getWeight,
		setWeight: setWeightInLocalStorage,
		setLength: setLengthInLocalStorage,
	} = useBmi()
	const [length, setLength] = useState<number | undefined>(getLength())
	const [weight, setWeight] = useState<number | undefined>(getWeight())
	const [bmi, setBmi] = useState<number | undefined>(
		calculateBmi(weight, length),
	)

	const onBmiCalculated = (length: number, weight: number) => {
		setLength(length)
		setLengthInLocalStorage(length)
		setWeight(weight)
		setWeightInLocalStorage(weight)
		setBmi(calculateBmi(weight, length))
	}

	const resolveDescription = (bmi: number) => {
		if (!bmi) {
			return undefined
		}
		if (bmi < 18.5) {
			return underweight.value
		} else if (bmi < 25) {
			return normalWeight.value
		} else if (bmi < 30) {
			return overweight.value
		} else {
			return obesity.value
		}
	}

	return (
		<Flex flexDirection={"column"} py={6.5}>
			<BmiHeader description={preamble.value} header={header.value} />
			<BmiCard
				description={calculatorPreamble.value}
				header={calculatorTitle.value}
				length={length}
				onBmiCalculated={onBmiCalculated}
				showResultBar={true}
				weight={weight}
				inputTexts={{
					length: heightInput,
					weight: weightInput,
					button: submitButton,
				}}
				barTexts={{
					bmi: bmiString,
					underWeight: underWeight,
					normalWeight: normalweight,
					overWeight: overWeight,
					obese,
				}}
				resultTexts={{
					yourBmi: yourBMI,
				}}
			/>
			{bmi && (
				<BmiResult
					bmi={bmi}
					description={resolveDescription(bmi)}
					yourBmiText={yourBMI}
				/>
			)}
		</Flex>
	)
}
